// extracted by mini-css-extract-plugin
export default {"btnpwd":"e3414863c7"};